<template>
  <div class="docs-status">
    <span :class="`docs-status-enabled ${statusClass}`" v-if="status === true">
      {{ $t('docs_status_enable') }}
    </span>
    <span :class="`docs-status-disabled ${statusClass}`" v-else>
      {{ $t('docs_status_disable') }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    status: {
      type: Boolean,
    },
    size: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    statusClass() {
      return this.size === 'small' ? 'docs-status-small' : '';
    },
  },
};
</script>
<style lang="less" scoped>
.docs-status-disabled {
  padding: 3px 10px;
  text-align: center;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid #ffccc7;
  background: #fff1f0;
  white-space: nowrap;
  color: #f5222d;
}

.docs-status-enabled {
  padding: 3px 10px;
  text-align: center;
  gap: 4px;
  white-space: nowrap;
  border-radius: 4px;
  border: 1px solid #b7eb8f;
  background: #f6ffed;
  color: #52c41a;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.docs-status-small {
  padding: 4px 2px;
  font-size: 12px;
  margin-right: 5px;
}
</style>
